import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import './BuildingList.css';
import BuildingRegistrationModal from "./modals/BuildingRegistrationModal";
import WarningLoginModal from "./modals/WarningLoginModal";
import { Header, Sidebar, LoadingPage } from "../common";
import { BuildingContext } from "../contexts/BuildingContext";


const BuildingList = () => {
  const { buildings, setBuildings, fetchBuildings, addBuilding } = useContext(BuildingContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userRole, setUserRole] = useState(sessionStorage.getItem("role"));
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if(sessionStorage.getItem("token")){
      // console.log("토큰", sessionStorage.getItem("token"))
      fetchBuildings().then(isSuccessful => {
        setIsLoading(isSuccessful)
      });
    } else {
      setIsLoading(false)
    }
  }, []);

  const handleRowClick = (id) => {
    navigate(`/building-detail/${id}`);
  };

  const handleBuildingRegisterClick = () => {
    if (userRole === "GUEST" && buildings.length >= 1) {
      setIsWarningModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };

  if (isLoading) {
    return <LoadingPage />;
  }
  return (
    <div className="buildinglist-page">
      <Sidebar />
      <div className="sideBarElseContainer">
        <Header pageName="건물 정보"/>
        <div className="content-container">
          <div className="building-list-container">
            <div className="header-row">
              <div className="building-count">
                건물전체 <span>{buildings.length}</span>
              </div>
              <button className="add-building-button" onClick={handleBuildingRegisterClick}>
                + 건물추가
              </button>
            </div>
            <div className="building-list">
              {buildings.length === 0 ? (
                // 건물이 없을 경우
                <div className="no-building-container">
                  <img src="/noBuilding.png" alt="No Building" className="no-building-img" />
                  <div className="no-building-label">건물을 추가하고 관리를 시작해보세요</div>
                  <div className="specific-info-row">
                    <div className="specific-info-1">
                      <div className="room-num">총 호실 -</div>
                      <div className="empty-room-num">공실 -</div>
                      <div className="floor-num">지상 층 수 -</div>
                      <div className="underfloor-num">지하 층 수 -</div>
                      <div className="total-area">연면적 -</div>
                    </div>
                    <div className="specific-info-2">
                      <div className="last-pay">마지막 공과금(YY.MM)</div>
                      <div className="info-tax-elec">과세 전기세 -</div>
                      <div className="info-taxfree-elec">비과세 전기세 -</div>
                      <div className="info-water">수도세 -</div>
                    </div>
                  </div>
                </div>
              ) : (
                // 건물이 있을 경우
                buildings.map((building) => (
                  <div className="building-row" key={building.id} onClick={() => handleRowClick(building.id)}>
                    <div className="building-info-row">
                      <div className="building-name">{building.buildingName}</div>
                      <div className="building-address">
                        <img src="/addressIcon.png" alt="Address Icon" className="address-icon" />
                        {building.address}
                      </div>
                    </div>
                    <div className="specific-info-row">
                      <div className="specific-info-1">
                        <div className="room-num">총 호실
                          <div className="specific-info-input">{building.roomTotalNumber}</div>
                        </div>
                        <div className="empty-room-num">공실
                          <div className="specific-info-input">{building.roomEmptyNumber}</div>
                        </div>
                        <div className="floor-num">지상 층 수
                          <div className="specific-info-input">{building.buildingGroundFloor}</div>
                        </div>
                        <div className="underfloor-num">지하 층 수
                          <div className="specific-info-input">{building.buildingBasementFloor}</div>
                        </div>
                        <div className="total-area">연면적
                          <div className="specific-info-input">{building.buildingTotalArea}m²</div>
                        </div>
                      </div>
                      <div className="separator"></div>
                      <div className="specific-info-2">
                        <div className="last-pay">마지막 공과금
                          <div className="specific-info-input">
                            {building.latestUtilitiesDate ? `(${building.latestUtilitiesDate})` : `(YY.MM)`}
                          </div>
                        </div>
                        <div className="info-tax-elec">과세 전기세
                          <div className="specific-info-input">{building.totalElecTax}</div>
                        </div>
                        <div className="info-taxfree-elec">비과세 전기세
                          <div className="specific-info-input">{building.totalElecTaxFree}</div>
                        </div>
                        <div className="info-water">수도세
                          <div className="specific-info-input">{building.buildingWaterPrice}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            <BuildingRegistrationModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
            />
            <WarningLoginModal
              isOpen={isWarningModalOpen}
              onClose={() => setIsWarningModalOpen(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildingList;